import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import AutoScopeStyles from '../Utilities/Decorators/AutoScopeStylesDecorator';
import applyDecoratorsDoNotUseInNewCode from '../Utilities/Decorators/ApplyDecorators';

function UseFocusEventIfOnEventIsUndefined(on) {
    if(on === undefined || on === null) {
        return "focus";
    }
    return on;
}

class PopupView extends React.PureComponent {
    render() {
        const contentsIsArray = Array.isArray(this.props.contents);
        const renderedContents = contentsIsArray ? this.renderContentsAsBullets(this.props.contents) : this.props.contents;

        const heading = this.props.heading || "";
        const onEventOrEvents = UseFocusEventIfOnEventIsUndefined(this.props.on);
        const offset = this.props.offset || 0;

        return (
            <Popup
                trigger={ this.props.element }
                on={ onEventOrEvents }
                wide="very"
                position={ this.props.position || "right center" }
                horizontaloffset={ offset }>
                <Popup.Header>{ heading }</Popup.Header>
                <Popup.Content>
                    { renderedContents }
                </Popup.Content>
            </Popup>

        );
    }

    renderContentsAsBullets = (contents) => {
        return contents.map((c, index) =>
            <p key={index}>• {c}</p>
        );
    }

    static propTypes = {
        element: PropTypes.object.isRequired,
        heading: PropTypes.string,
        on: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string)
        ]),
        contents: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string)
        ]).isRequired,
        offset: PropTypes.number,
        position: PropTypes.string
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(PopupView);
